import React from "react";
import styles from "./App.module.css";
import { NavigationBar } from "./NavigationBar/NavigationBar";
import { DropDownBar } from "./DropDownMenu/DropDownBar";
import { DropDownMenu } from "./DropDownMenu/DropDownMenu";
import { Header } from "./Header/Header";
import { Main } from "./Main/Main";
import { Footer } from "./Footer/Footer";
import { Gallery } from "./Gallery/Gallery";
import { GalleryAmigurumis } from "./GalleryAmigurumis/GalleryAmigurumis";
import { GalleryAnime } from "./GalleryAmigurumis/GalleryAnime";
import { GalleryChenille } from "./GalleryAmigurumis/GalleryChenille";
import { GalleryKeychain } from "./GalleryAmigurumis/GalleryKeychain";
import { GalleryRandom } from "./GalleryAmigurumis/GalleryRandom";
import { AboutMe } from "./AboutMe/AboutMe";
import { Contact } from "./Contact/Contact";
import { Faq } from "./Faq/Faq";
import { Banner } from "./Banner/Banner";

function App() {
  const [hidden, setHidden] = React.useState(false);
  const [showGallery, setShowGallery] = React.useState(false);
  const [showGalleryAmigurumis, setShowGalleryAmigurumis] =
    React.useState(false);
  const [showGalleryAnime, setShowGalleryAnime] = React.useState(false);
  const [showGalleryChenille, setShowGalleryChenille] = React.useState(false);
  const [showGalleryKeychain, setShowGalleryKeychain] = React.useState(false);
  const [showGalleryRandom, setShowGalleryRandom] = React.useState(false);

  const [showAboutMe, setShowAboutMe] = React.useState(false);
  const [showFaq, setShowFaq] = React.useState(false);
  const [showContact, setShowContact] = React.useState(false);
  const [showDropDownMenu, setShowDropDownMenu] = React.useState(false);

  function inicio() {
    setHidden(false);
    setShowAboutMe(false);
    setShowGallery(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }

  function gallery() {
    setHidden(true);
    setShowGallery(true);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowAboutMe(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }

  function galleryAmigurumis() {
    setHidden(true);
    setShowGallery(false);
    setShowGalleryAmigurumis(true);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowAboutMe(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }
  function galleryAnime() {
    setHidden(true);
    setShowGallery(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(true);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowAboutMe(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }
  function galleryChenille() {
    setHidden(true);
    setShowGallery(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(true);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowAboutMe(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }
  function galleryKeychain() {
    setHidden(true);
    setShowGallery(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(true);
    setShowGalleryRandom(false);
    setShowAboutMe(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }
  function galleryRandom() {
    setHidden(true);
    setShowGallery(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(true);
    setShowAboutMe(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }

  function aboutMe() {
    setHidden(true);
    setShowAboutMe(true);
    setShowGallery(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowFaq(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }

  function contact() {
    setHidden(true);
    setShowGallery(false);
    setShowAboutMe(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowFaq(false);
    setShowContact(true);
    setShowDropDownMenu(false);
  }

  function faq() {
    setShowFaq(true);
    setHidden(true);
    setShowGallery(false);
    setShowGalleryAmigurumis(false);
    setShowGalleryAnime(false);
    setShowGalleryChenille(false);
    setShowGalleryKeychain(false);
    setShowGalleryRandom(false);
    setShowAboutMe(false);
    setShowContact(false);
    setShowDropDownMenu(false);
  }

  function dropDownMenu() {
    showDropDownMenu === false
      ? setShowDropDownMenu(true)
      : setShowDropDownMenu(false);
  }

  return (
    <div className={styles.app}>
      <Banner></Banner>
      <DropDownBar
        inicio={inicio}
        gallery={gallery}
        dropDownMenu={dropDownMenu}
      ></DropDownBar>
      {showDropDownMenu && (
        <DropDownMenu
          inicio={inicio}
          gallery={gallery}
          galleryAmigurumis={galleryAmigurumis}
          galleryAnime={galleryAnime}
          galleryChenille={galleryChenille}
          galleryKeychain={galleryKeychain}
          galleryRandom={galleryRandom}
          aboutMe={aboutMe}
          contact={contact}
          faq={faq}
        ></DropDownMenu>
      )}
      <NavigationBar
        inicio={inicio}
        gallery={gallery}
        galleryAmigurumis={galleryAmigurumis}
        galleryAnime={galleryAnime}
        galleryChenille={galleryChenille}
        galleryKeychain={galleryKeychain}
        galleryRandom={galleryRandom}
        aboutMe={aboutMe}
        contact={contact}
        faq={faq}
      ></NavigationBar>

      {!hidden && (
        <Header setHidden={setHidden} setShowGallery={setShowGallery}></Header>
      )}
      {!hidden && (
        <Main
          setHidden={setHidden}
          setShowGallery={setShowGallery}
          setShowAboutMe={setShowAboutMe}
        ></Main>
      )}
      {showGallery && (
        <Gallery
          setShowGallery={setShowGallery}
          setShowGalleryAmigurumis={setShowGalleryAmigurumis}
          setShowGalleryAnime={setShowGalleryAnime}
          setShowGalleryChenille={setShowGalleryChenille}
          setShowGalleryKeychain={setShowGalleryKeychain}
          setShowGalleryRandom={setShowGalleryRandom}
        ></Gallery>
      )}
      {showGalleryAmigurumis && <GalleryAmigurumis></GalleryAmigurumis>}
      {showGalleryAnime && <GalleryAnime></GalleryAnime>}
      {showGalleryChenille && <GalleryChenille></GalleryChenille>}
      {showGalleryKeychain && <GalleryKeychain></GalleryKeychain>}
      {showGalleryRandom && <GalleryRandom></GalleryRandom>}
      {showAboutMe && <AboutMe></AboutMe>}
      {showContact && <Contact></Contact>}
      {showFaq && <Faq></Faq>}
      <Footer
        inicio={inicio}
        gallery={gallery}
        galleryAmigurumis={galleryAmigurumis}
        galleryAnime={galleryAnime}
        galleryChenille={galleryChenille}
        galleryKeychain={galleryKeychain}
        galleryRandom={galleryRandom}
        aboutMe={aboutMe}
        contact={contact}
        faq={faq}
      ></Footer>
    </div>
  );
}

export default App;
